/* global fetch, FormData */
import Store from 'store/store'
import showError from 'controllers/error'

const api = endpoint => Store.APIServer.url.get() + endpoint

// Polling abstraction which will try to ping API server until either the
// version is returned or the max attempts is reached
const polling = {
  timer: null,
  attempts: 0,
  start: function () {
    this.stop()
    if (!Store.APIServer || !Store.APIServer.url.get()) return

    if (this.attempts >= Store.APIServer.pollingMaxAttempts.get()) {
      console.warn('APIServer max polling attempts reached')
      Store.APIServer = null
      if (window.ENV.production) {
        showError(`Impossible de contacter ${Store.APIServer.url.get()}: l’export PDF ne sera pas disponible.`, {
          log: false,
          stacktrace: false
        })
      }
      return
    }

    this.timer = setTimeout(async () => {
      this.attempts++
      try {
        const ping = await fetch(api('ping'), { method: 'GET' })
        const response = await ping.json()
        if (!response || !response.version) throw new Error('Ping malformed')

        Store.APIServer.version.set(response.version)
      } catch (error) {
        this.start()
      }
    }, Store.APIServer.pollingInterval.get())
  },

  stop: function () {
    clearTimeout(this.timer)
  }
}

// Simple logger abstraction with support for queued message when the server is
// not up yet
const logger = {
  get ready () {
    return !!Store.APIServer.version.get()
  },

  log: async function (action, data) {
    if (!window.ENV.production) return
    if (this.ready) this.send(action, data)
    else this.queue(action, data)
  },

  send: (action, data) => fetch(api('log/' + window.ENV.name), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action, data })
  }),

  queue: function (action, data) {
    Store.APIServer.version.subscribeOnce(() => {
      this.send(action, data)
    })
  }
}

export default {
  polling,
  log: logger.log.bind(logger),

  pdf: async ({
    svgString,
    files = {}, // { 'filename': <blob>, … }
    pdfOptions = {}
  } = {}) => {
    const body = new FormData()

    for (const filename in files) {
      body.append(filename, files[filename], filename)
    }

    body.append('svg', svgString)
    body.append('options', JSON.stringify(pdfOptions))

    const response = await fetch(api('pdf'), {
      method: 'POST',
      headers: {
        // IMPORTANT: multipart/form-data POST won't work with the Fetch API if
        // the 'Content-Type' header is explicitly set: it must be left
        // undefined so that the right 'boundary=' value can be added. WTF
        // SEE https://stackoverflow.com/a/39281156
      },
      body
    })

    const location = (Store.APIServer.public.get() || api()) + response.headers.get('Location')

    if (!response.ok) {
      console.error(response)
      throw new Error(response.status + ': ' + response.statusText)
    }
    return { response, location }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/api-server.js